import {EventBase} from "shared/utilities/Events/EventManager";


export class ShowGroupOptions extends EventBase{
    ReturnType: void;

    constructor()
    {
        super();
    }

    public static GetName() {
        return 'ShowGroupOptions';
    }
}